import React, { createContext, useContext, useEffect, useState } from "react";
import CommonService from "../services/CommonService";

const userContext = createContext();

const UserProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    user: null,
    loading: false,
  });

  const fetchProfile = () => {
    setAuth((prevState) => ({
      ...prevState,
      loading: true,
    }));

    CommonService.get("/profile")
      .then((data) => {
        setAuth({
          user: data?.user,
          loading: false,
        });
      })
      .catch((error) => {
        setAuth((prevState) => ({
          ...prevState,
          loading: false,
        }));
      });
  };

  // Function to refetch the profile data
  const refetchProfile = () => {
    fetchProfile();
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  return (
    <userContext.Provider value={{ auth, setAuth, refetchProfile }}>
      {children}
    </userContext.Provider>
  );
};

const useAuth = () => useContext(userContext);

export { useAuth, UserProvider };
